import { isExperimentalFeatureEnabled, ONE_KILO_BYTE, timeStampNow } from '@datadog/browser-core';
import { record } from '../domain/record';
import { setSegmentBytesLimit, startSegmentCollection } from '../domain/segmentCollection';
import { send } from '../transport/send';
import { RecordType } from '../types';
export function startRecording(lifeCycle, configuration, sessionManager, viewContexts, worker) {
  if (isExperimentalFeatureEnabled('lower-batch-size')) {
    setSegmentBytesLimit(22 * ONE_KILO_BYTE);
  }
  var _a = startSegmentCollection(lifeCycle, configuration.applicationId, sessionManager, viewContexts, function (data, metadata, rawSegmentBytesCount, flushReason) {
      return send(configuration.sessionReplayEndpointBuilder, data, metadata, rawSegmentBytesCount, flushReason);
    }, worker),
    addRecord = _a.addRecord,
    stopSegmentCollection = _a.stop;
  var _b = record({
      emit: addRecord,
      defaultPrivacyLevel: configuration.defaultPrivacyLevel
    }),
    stopRecording = _b.stop,
    takeFullSnapshot = _b.takeFullSnapshot,
    flushMutations = _b.flushMutations;
  var unsubscribeViewEnded = lifeCycle.subscribe(4 /* VIEW_ENDED */, function () {
    flushMutations();
    addRecord({
      timestamp: timeStampNow(),
      type: RecordType.ViewEnd
    });
  }).unsubscribe;
  var unsubscribeViewCreated = lifeCycle.subscribe(2 /* VIEW_CREATED */, function (view) {
    takeFullSnapshot(view.startClocks.timeStamp);
  }).unsubscribe;
  return {
    stop: function () {
      unsubscribeViewEnded();
      unsubscribeViewCreated();
      stopRecording();
      stopSegmentCollection();
    }
  };
}
